import { render } from "./CreateLeadModal.vue?vue&type=template&id=b0d0d5d0&scoped=true&ts=true&lang=pug"
import script from "./CreateLeadModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateLeadModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateLeadModal.vue?vue&type=style&index=0&id=b0d0d5d0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d0d5d0"]])

export default __exports__